module.exports = __webpack_public_path__ + "static/media/age.d86f4d44.svg";